import { IReportService } from "../../service/report/ReportService";

export default class GetDataReport5Interactor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(reportingPeriodId: number) {
    return this.reportService.getDataReport5(reportingPeriodId);
  }
}
